import { useEffect } from "react";

export const NoAds = () => {
  useEffect(() => {
    document.body.classList.add("noads");
    return () => {
      document.body.classList.remove("noads");
    };
  }, []);
  return null;
};

export const NoLeaderboardAd = () => {
  useEffect(() => {
    document.body.classList.add("nolb");
    return () => {
      document.body.classList.remove("nolb");
    };
  }, []);
  return null;
};
